import { TeamDB } from "@aura-frontend/omnibus-az-client";
import { ListOption } from "@win-reality/react-ui";

export type TeamOption = ListOption<
  string,
  {
    parentName: string | null;
    sport?: TeamDB["sport"];
  }
>;

// `parent_name` is not declared on TeamDB in the OpenAPI spec, but the
// `/teams/search` response carries it (set via the rename / upload-roster
// endpoints — see openapi.yml `parentName` query param). The wire format
// uses snake_case (`parent_name`); we also fall back to camelCase in case
// the backend ever normalizes it.
type TeamDBWithParentName = TeamDB & {
  parent_name?: string | null;
  parentName?: string | null;
};

export const mapTeamDBToOption = (team: TeamDB): TeamOption => {
  const raw = team as TeamDBWithParentName;
  const parentName = raw.parent_name ?? raw.parentName ?? null;
  const option = {
    value: team.external_ids?.[0] ?? "",
    label: team.known_names?.[0] ?? "",
    meta: {
      parentName,
      sport: team.sport,
    },
  };

  return option;
};
